import { type RtkQueryLayers } from '../../core';
import { fronteggUsersApi } from './users.frontegg';
import { fronteggRolesApi } from './roles.frontegg';

export const fronteggUsersRTKSlice: RtkQueryLayers = {
  reducers: {
    [fronteggUsersApi.reducerPath]: fronteggUsersApi.reducer,
    [fronteggRolesApi.reducerPath]: fronteggRolesApi.reducer,
  },
  middlewares: [fronteggUsersApi.middleware, fronteggRolesApi.middleware],
};
